module.exports = __webpack_public_path__ + "img/DTIO2.d6e43f13.png";